import angular from 'angular';

const services = angular.module('applicationModule.priceListsServices', []);


services.factory('PriceList', ['PriceListAPI', function (PriceListAPI) {
    return {
        getList: function (appId, params) {
            return PriceListAPI.all(appId, params)
                .then(function (response) {
                    return response.data.posts;
                });
        },
        get: function (id, appId) {
            return PriceListAPI.get(id, appId);
        },
        save: function (data, editMode) {
            return PriceListAPI.store(data, editMode);
        },
        remove: function (id) {
            return PriceListAPI.remove(id);
        },
        importData: function (appId, file) {
            return PriceListAPI.importData(appId, file);
        },
        getExampleXls: function () {
            return PriceListAPI.getExampleXls();
        },
        syncroPriceList: function (appId) {
            return PriceListAPI.syncroPriceList(appId);
        },
        getSyncroPriceList: function (appId) {
            return PriceListAPI.getSyncroPriceList(appId);
        },
        getSyncroPriceVersion: function (appId) {
            return PriceListAPI.getSyncroPriceVersion(appId);
        },
        syncroPriceListByDay: function (appId, date) {
            return PriceListAPI.syncroPriceListByDay(appId, date);
        },
        downloadImagesAndCategories: function (appId) {
            return PriceListAPI.downloadImagesAndCategories(appId);
        },
        getData: function (appId) {
            return PriceListAPI.getData(appId);
        }
    };
}]);

services.service('PriceListAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    var API_URL = AppsoupAPI.API_URL + '/app/price_lists/';

    this.all = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.get = function (id, appId) {
        return $http.get(API_URL + id, {params: {application_id: appId}});
    };

    this.store = function (data, editMode) {
        if (editMode) {
            return $http.put(API_URL + data.id, data);
        } else {
            return $http.post(API_URL, data);
        }
    };

    this.remove = function (id) {
        return $http.delete(API_URL + id);
    };

    this.importData = function (appId, file) {
        return Upload.upload({
            url: API_URL + appId + '/import/data',
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: {},
            file: file
        });
    };

    this.getExampleXls = function () {
        return $http.get(API_URL + 'download/example');
    };

    this.syncroPriceList = function (appId) {
        return $http.get(API_URL + 'syncro/list/' + appId);
    };

    this.syncroPriceListByDay = function (appId, date) {
        return $http.get(API_URL + 'syncro/get-by-date/' + appId + '/' + date);
    };

    this.getSyncroPriceList = function (appId) {
        return $http.get(API_URL + 'syncro/get-list/' + appId);
    };

    this.getSyncroPriceVersion = function (appId) {
        return $http.get(API_URL + 'syncro/get-version/' + appId);
    };

    this.downloadImagesAndCategories = function (appId) {
        return $http.get(API_URL + 'syncro/download-images/' + appId);
    };

    this.getData = function (appId) {
        return $http.get(API_URL + 'syncro/index/' + appId);
    };

}]);

export default services;
